document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll('.swiper-slider').forEach(slider => {
        new Swiper(slider, Object.assign({}, defaultSettings, slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {}));
    });

    let sliderTimelinePic = new Swiper('.swiper-timeline-pic', {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let sliderVenues = new Swiper('.swiper-venues', {
        loop: true,
        navigation: {
            prevEl: '.swiper-venues-prev',
            nextEl: '.swiper-venues-next'
        },
        breakpoints: {
            340: {
                slidesPerView: 1,
                spaceBetween: 50,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 40,
                autoHeight: false,
            },
            1024: {
                slidesPerView: 2.3,
                spaceBetween: 80,
                autoHeight: false,
            },
        },
    });

    let sliderTimelineDesc = new Swiper('.swiper-timeline-desc', Object.assign(
        {},
        defaultSettings,
        {
            navigation: {
                prevEl: '.swiper-timeline-prev',
                nextEl: '.swiper-timeline-next'
            },
            pagination: {
                el: '.swiper-timeline-dots',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}">${this.slides[index].dataset.heading}</span>`;
                }
            }
        }
    ));

    sliderTimelinePic.controller.control = sliderTimelineDesc;
    sliderTimelineDesc.controller.control = sliderTimelinePic;
});